const systemAlertStatusCodes = {
  new: 'NEW',
  filtered: 'FILTERED',
  rfiSent: 'RFI_SENT',
  rfiReceived: 'RFI_RECEIVED',
};

export { systemAlertStatusCodes };
